import { AddressValidatedJsonldAddressValidatedPostWrite } from '@/api/generated';
import { yupResolver } from '@hookform/resolvers/yup';
import { useModal } from 'context/Modal/Context';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

const addressResult = () =>
  yup
    .object({
      firstName: yup.string().required(),
      lastName: yup.string().required(),
      additionalAddress: yup.string(),
      phone: yup.string().required(),
      isDefaultShipping: yup.boolean(),
      isDefaultBilling: yup.boolean(),
    })
    .required();

type AddressResultFormValues = yup.InferType<ReturnType<typeof addressResult>>;

type Props = {
  handleCreateAddress: (data: AddressValidatedJsonldAddressValidatedPostWrite, responseId: string) => void;
  responseId: string;
};

const useAddressResultForm = ({ handleCreateAddress, responseId }: Props) => {
  const { closeModal } = useModal();
  const formMethods = useForm<AddressResultFormValues>({
    resolver: yupResolver(addressResult()),
    mode: 'onSubmit',
  });
  const { handleSubmit } = formMethods;

  const onSubmit = async (v: AddressResultFormValues) => {
    await handleCreateAddress(v, responseId);
    closeModal();
  };

  return { formMethods, onSubmit: handleSubmit(onSubmit) };
};
export default useAddressResultForm;
